import { graphql } from "gatsby";
import React, { FC } from "react";

import { useLabels } from "../../../contexts/labels";
import { FileList } from "../../file-list/file-list";

export interface FileCategorySectionProps extends Queries.FileCategoryDataFragment {}

export const FileCategorySection: FC<FileCategorySectionProps> = (props) => {
  const { labels } = useLabels();
  return <FileList {...props} labels={labels} />;
};

export const query = graphql`
  fragment FileCategoryData on ContentfulFileCategory {
    name
    node_locale
    slug
    files {
      ...FileData
    }
  }
`;
